
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 38 38","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke-width":"4","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M30.631 32.997V31.81a4.776 4.776 0 00-2.406-4.146l-4.753-2.727M15.502 24.937l-4.753 2.727a4.778 4.778 0 00-2.407 4.147v1.186","stroke":"#111","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M19.486 26.651h0c-3.517 0-6.368-3.647-6.368-7.165v-3.184a6.369 6.369 0 016.368-6.368h0a6.369 6.369 0 016.369 6.368v3.184c0 3.518-2.851 7.165-6.369 7.165z","stroke":"#111","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M1.973 19.486C1.973 29.16 9.814 37 19.486 37 29.16 37 37 29.159 37 19.486c0-9.672-7.841-17.513-17.514-17.513","stroke":"#111","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{staticClass:"circle",attrs:{"d":"M7.324 1a6.324 6.324 0 110 12.649A6.324 6.324 0 017.324 1zm3.156 4.214a.973.973 0 00-1.374-.072L6.513 7.474l-.97-.873-.096-.076a.973.973 0 00-1.206 1.523l1.622 1.459.096.076a.973.973 0 001.205-.076l3.244-2.919.085-.087a.973.973 0 00-.013-1.287z","fill":"#000"}})])])
          )
        }
      }
    